import React from "react";
import { IJourneyLevel } from "./types";
import LottieWebPlayer from "./LottieWebPlayer";

const playIconJson = require("./assets/jsons/playIcon.json");
const storyGemJson = require("./assets/jsons/story_gem.json");
const gemBlankJson = require("./assets/jsons/gem_blank.json");

interface JourneyCardProps {
  level: IJourneyLevel;
  isCurrent: boolean;
  onClick: () => void;
}

const CURRENT_COLOR = "#9747FF";
const COMPLETED_COLOR = "#76B8F5";

const JourneyCard: React.FC<JourneyCardProps> = ({
  level,
  isCurrent,
  onClick,
}) => {
  const isPending = level.status?.toLowerCase() === "pending";
  const isRestarted = level.status?.toLowerCase() === "restarted";
  const cardColor = isCurrent ? CURRENT_COLOR : COMPLETED_COLOR;
  const borderColor = isCurrent ? "#7105FF" : "#3395F0";

  const getChapterGem = (idx: number) => {
    if (isRestarted) return storyGemJson;
    const isFinished = level.status?.toLowerCase() === "finished";
    const chapterDone =
      level.chapters?.[idx]?.status?.toLowerCase() === "completed";
    return isFinished || chapterDone ? storyGemJson : gemBlankJson;
  };

  return (
    <button
      onClick={onClick}
      aria-label={`Story: ${level.name}`}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Top badge: play circle for current, gems row for completed */}
      <div style={{ marginBottom: -14, zIndex: 2, position: "relative" }}>
        {isCurrent ? (
          <LottieWebPlayer
            source={playIconJson}
            style={{ width: 90, height: 90, marginBottom: -20 }}
            autoPlay
            loop
          />
        ) : (
          <div
            style={{
              backgroundColor: "#76B8F5",
              border: "1px solid #3395F0",
              borderRadius: 8,
              padding: "3px 10px",
              display: "flex",
              flexDirection: "row",
              gap: 4,
              alignItems: "center",
            }}
          >
            {[0, 1, 2].map((idx) => (
              <LottieWebPlayer
                key={idx}
                source={getChapterGem(idx)}
                style={{ width: 42, height: 42 }}
                autoPlay
                loop
              />
            ))}
          </div>
        )}
      </div>

      {/* Card body */}
      <div
        style={{
          backgroundColor: cardColor,
          // border: `1px solid ${borderColor}`,
          borderRadius: 16,
          padding: "38px 16px 20px",
          width: 300,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 12,
          // boxShadow: "0 6px 16px rgba(0,0,0,0.3)",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Thumbnail box */}
        <div
          style={{
            backgroundColor: "#FFFFFF",
            borderRadius: 10,
            width: 104,
            height: 104,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            overflow: "hidden",
          }}
        >
          {isPending ? (
            <span style={{ fontSize: 46, fontWeight: 700, color: "#444" }}>
              ?
            </span>
          ) : (
            <LottieWebPlayer
              source={level.storyImage || null}
              style={{ width: 64, height: 64 }}
              autoPlay
              loop
            />
          )}
        </div>

        {/* Title */}
        <span
          style={{
            color: "#FFFFFF",
            fontWeight: 700,
            fontSize: 24,
            lineHeight: 1.3,
            textAlign: "left",
            flex: 1,
          }}
        >
          {level.name}
        </span>
      </div>

      {/* Speech-bubble downward triangle */}
      <div
        style={{
          width: 0,
          height: 0,
          borderLeft: "22px solid transparent",
          borderRight: "22px solid transparent",
          borderTop: `24px solid ${cardColor}`,
          marginTop: -1,
          zIndex: 1,
        }}
      />
    </button>
  );
};

export default JourneyCard;
